/**
 * @license
 * Copyright TWISS.IO
 * All Rights Reserved.
 * Licensed under the MIT License.
 */
import { Component, Input, ViewEncapsulation, AfterViewInit, OnDestroy } from "@angular/core";
import { AuthService } from "@app/@core/services";
import { Router } from "@angular/router";
import { PageService, SidebarService } from "@auth/services";
import { PusherService } from "@app/@core/services/pusher";
import { ApiService } from "@app/@core/services/api";
import { MessageService } from "@app/@shared/components/message/message.service";
import { Subscription, Subject } from "rxjs";
import { Online } from "@app/models";
import Typed from "typed.js";
import { saveAs } from "file-saver";
import { MatDialog } from "@angular/material/dialog";
import { UpdateProfileDialogComponent } from "@app/@shared/components/update-profile-dialog/update-profile-dialog.component";

@Component({
  selector: "pg-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class HeaderComponent implements AfterViewInit, OnDestroy {
  @Input() online: Online;
  @Input() mobileSidebar: boolean = false;
  @Input() spinSymbol: boolean = false;

  @Input() _moduleAlerts: boolean = false;
  @Input() _moduleTeams: boolean = false;
  @Input() _moduleChats: boolean = false;
  @Input() _moduleSearch: boolean = false;

  _reportSubscriptions: Subscription;
  logout_menu_show: boolean = false;
  downloading: boolean = false;
  refresh: boolean = false;

  _type_options = {
    strings: ["colleagues", "submissions", "friends", "schedules", "teammates", "messages", "clients", "leads", "policies", "payroll"],
    typeSpeed: 70,
    backSpeed: 30,
    startDelay: 1000,
    backDelay: 2500,
    loop: true,
    shuffle: true,
    smartBackspace: false,
    cursorChar: "|",
  };

  constructor(public pageService: PageService, private router: Router, public sidebarService: SidebarService, public authService: AuthService, public apiService: ApiService, private _notification: MessageService, private pusherService: PusherService, public dialog: MatDialog) {
    this._reportSubscriptions = this.pusherService.monitorReports().subscribe((data) => {
      if (data['user_uuid'] == this.authService.user.user_uuid) {
        this.authService.getAuthenticatedUser().subscribe(() => {});
      }
    });
  }

  ngOnDestroy() {
    if (this._reportSubscriptions) this._reportSubscriptions.unsubscribe();
  }

  ngAfterViewInit() {
    if (this._moduleSearch) new Typed(".typed-element", this._type_options);
  }

  openConnectionSwal() {
    this.pageService.toggleConnectionSwal();
  }

  routeHome() {
    if (this.authService.user.roles.is_associate) this.router.navigate(["/authenticated/associates"]);
    else if (this.authService.user.roles.is_admin || this.authService.user.roles.is_staff) this.router.navigate(["/authenticated/admin"]);
  }

  reportsLength() {
    if (this.authService.user) {
      return Object.keys(this.authService.user.reports).length;
    } else {
      return 0;
    }
  }

  downloadReport(uuid, filename) {
    this.downloading = true;
    setTimeout(() => {
      this.apiService.download("admin/download-reports/" + uuid).toPromise().then((blob) => {
        if (blob) saveAs(blob, filename);
        else this._notification.create("danger", "Error: File does not exists on the server.", { Position: "top", Style: "bar", Duration: 2000 });
        this.downloading = false;
      });
    }, 1000);
  }

  updateProfileDialog() {
    const dialogRef = this.dialog.open(UpdateProfileDialogComponent, {
      width: "600px",
      disableClose: true,
      data: this.authService.user,
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.refresh = true;
      if (result["error"] === false) {
        this._notification.create("success", "Profile updated successfully!", { Position: "top", Style: "bar", Duration: 2000 });
        this.authService.user = result["data"];
      }
      setTimeout(() => {this.refresh = false;});
    });
  }
}
